const owaspLcncBaseUrl = "https://owasp.org/www-project-top-10-low-code-no-code-security-risks/content/2022/en";
const owaspLlmBaseUrl = "https://genai.owasp.org/llmrisk";
const attackBaseUrl = "https://attack.mitre.org/techniques";
const genAiMatrixBaseUrl = "https://ttps.ai/technique";
const genAiMatrixCategoryBaseUrl = "https://ttps.ai/tactic";

type OwaspList = "LCNC" | "LLM";

export const owaspLcncToDisplayName: Record<string, string> = {
    ["LCNC-SEC-01"]: "account_impersonation",
    ["LCNC-SEC-02"]: "authorization_misuse",
    ["LCNC-SEC-03"]: "data_leakage_and_unexpected_consequences",
    ["LCNC-SEC-04"]: "authentication_and_secure_communication_failures",
    ["LCNC-SEC-05"]: "security_misconfiguration",
    ["LCNC-SEC-06"]: "injection_handling_failures",
    ["LCNC-SEC-07"]: "vulnerable_and_untrusted_components",
    ["LCNC-SEC-08"]: "data_and_secret_handling_failures",
    ["LCNC-SEC-09"]: "asset_management_failures",
    ["LCNC-SEC-10"]: "security_logging_and_monitoring_failures",
};

export const owaspLlmToDisplayName: Record<string, string> = {
    ["LLM-SEC-01"]: "prompt_injection",
    ["LLM-SEC-02"]: "sensitive_information_disclosure",
    ["LLM-SEC-03"]: "supply_chain",
    ["LLM-SEC-04"]: "data_and_model_poisoning",
    ["LLM-SEC-05"]: "improper_output_handling",
    ["LLM-SEC-06"]: "excessive_agency",
    ["LLM-SEC-07"]: "system_prompt_leakage",
    ["LLM-SEC-08"]: "vector_and_embedding_weaknesses",
    ["LLM-SEC-09"]: "misinformation",
    ["LLM-SEC-10"]: "unbounded_consumption",
};

export const anyOwaspToDisplayName: Record<string, string> = {
    ...owaspLcncToDisplayName,
    ...owaspLlmToDisplayName,
};

const owaspLcncUrls: Record<string, string> = {
    ["LCNC-SEC-01"]: `${owaspLcncBaseUrl}/LCNC-SEC-01-Account-Impersonation`,
    ["LCNC-SEC-02"]: `${owaspLcncBaseUrl}/LCNC-SEC-02-Authorization-Misuse`,
    ["LCNC-SEC-03"]: `${owaspLcncBaseUrl}/LCNC-SEC-03-Data-Leakage-and-Unexpected-Consequences`,
    ["LCNC-SEC-04"]: `${owaspLcncBaseUrl}/LCNC-SEC-04-Authentication-and-Secure-Communication-Failures`,
    ["LCNC-SEC-05"]: `${owaspLcncBaseUrl}/LCNC-SEC-05-Security-Misconfiguration`,
    ["LCNC-SEC-06"]: `${owaspLcncBaseUrl}/LCNC-SEC-06-Injection-Handling-Failures`,
    ["LCNC-SEC-07"]: `${owaspLcncBaseUrl}/LCNC-SEC-07-Vulnerable-and-Untrusted-Components`,
    ["LCNC-SEC-08"]: `${owaspLcncBaseUrl}/LCNC-SEC-08-Data-and-Secret-Handling-Failures`,
    ["LCNC-SEC-09"]: `${owaspLcncBaseUrl}/LCNC-SEC-09-Asset-Management-Failures`,
    ["LCNC-SEC-10"]: `${owaspLcncBaseUrl}/LCNC-SEC-10-Security-Logging-and-Monitoring-Failures`,
};

const owaspLlmUrls: Record<string, string> = {
    ["LLM-SEC-01"]: `${owaspLlmBaseUrl}/llm012025-prompt-injection`,
    ["LLM-SEC-02"]: `${owaspLlmBaseUrl}/llm022025-sensitive-information-disclosure`,
    ["LLM-SEC-03"]: `${owaspLlmBaseUrl}/llm032025-supply-chain`,
    ["LLM-SEC-04"]: `${owaspLlmBaseUrl}/llm042025-data-and-model-poisoning`,
    ["LLM-SEC-05"]: `${owaspLlmBaseUrl}/llm052025-improper-output-handling`,
    ["LLM-SEC-06"]: `${owaspLlmBaseUrl}/llm062025-excessive-agency`,
    ["LLM-SEC-07"]: `${owaspLlmBaseUrl}/llm072025-system-prompt-leakage`,
    ["LLM-SEC-08"]: `${owaspLlmBaseUrl}/llm082025-vector-and-embedding-weaknesses`,
    ["LLM-SEC-09"]: `${owaspLlmBaseUrl}/llm092025-misinformation`,
    ["LLM-SEC-10"]: `${owaspLlmBaseUrl}/llm102025-unbounded-consumption`,
};

const genAiMatrixUrls: Record<string, string> = {
    /* Reconnaissance */
    ["T_2_1"]: `${genAiMatrixCategoryBaseUrl}/reconnaissance.html`,
    ["T_2_1_1"]: `${genAiMatrixBaseUrl}/embedded_knowledge_exposure.html`,
    ["T_2_1_2"]: `${genAiMatrixBaseUrl}/rag_injection.html`,
    ["T_2_1_3"]: `${genAiMatrixBaseUrl}/rag_injection.html`,
    ["T_2_1_4"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,

    /* Resource Development */
    ["T_2_2"]: `${genAiMatrixCategoryBaseUrl}/resource_development.html`,
    ["T_2_2_1"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,
    ["T_2_2_2"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,
    ["T_2_2_3"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,

    /* Initial Access */
    ["T_2_3"]: `${genAiMatrixCategoryBaseUrl}/initial_access.html`,
    ["T_2_3_1"]: `${genAiMatrixBaseUrl}/rag_poisoning.html`,
    ["T_2_3_2"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,
    ["T_2_3_3"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,
    ["T_2_3_4"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,
    ["T_2_3_5"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,
    ["T_2_3_6"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,
    ["T_2_3_7"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,

    /* Execution */
    ["T_2_4"]: `${genAiMatrixCategoryBaseUrl}/execution.html`,
    ["T_2_4_1"]: `${genAiMatrixBaseUrl}/prompt-injection`,
    ["T_2_4_2"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,
    ["T_2_4_3"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,

    /* Persistence */
    ["T_2_5"]: `${genAiMatrixCategoryBaseUrl}/persistence.html`,
    ["T_2_5_1"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,
    ["T_2_5_2"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,
    ["T_2_5_3"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,

    /* Privilege Escalation */
    ["T_2_6"]: `${genAiMatrixCategoryBaseUrl}/privilege_escalation.html`,
    ["T_2_6_1"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,
    ["T_2_6_2"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,
    ["T_2_6_3"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,
    ["T_2_6_4"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,

    /* Defense Evasion */
    ["T_2_7"]: `${genAiMatrixCategoryBaseUrl}/defense_evasion.html`,
    ["T_2_7_1"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,
    ["T_2_7_2"]: `${genAiMatrixBaseUrl}/distraction.html`,
    ["T_2_7_3"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,
    ["T_2_7_4"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,
    ["T_2_7_5"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,
    ["T_2_7_6"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,
    ["T_2_7_7"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,
    ["T_2_7_8"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,
    ["T_2_7_9"]: `${genAiMatrixBaseUrl}/rag_injection.html`,
    ["T_2_7_10"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,

    /* Credential Access */
    ["T_2_8"]: `${genAiMatrixCategoryBaseUrl}/credential_access.html`,
    ["T_2_8_1"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,
    ["T_2_8_2"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,

    /* Discovery */
    ["T_2_9"]: `${genAiMatrixCategoryBaseUrl}/discovery.html`,
    ["T_2_9_1"]: `${genAiMatrixBaseUrl}/delimiters_and_special_character_extraction.html`,
    ["T_2_9_2"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,
    ["T_2_9_3"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,
    ["T_2_9_4"]: `${genAiMatrixBaseUrl}/embedded_knowledge_exposure.html`,
    ["T_2_9_5"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,
    ["T_2_9_6"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,

    /* Lateral Movement */
    ["T_2_10"]: `${genAiMatrixCategoryBaseUrl}/lateral_movement.html`,
    ["T_2_10_1"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,
    ["T_2_10_2"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,

    /* Collection */
    ["T_2_11"]: `${genAiMatrixCategoryBaseUrl}/collection.html`,
    ["T_2_11_1"]: `${genAiMatrixBaseUrl}/rag_data_harvesting.html`,
    ["T_2_11_2"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,
    ["T_2_11_3"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,
    ["T_2_11_4"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,
    ["T_2_11_5"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,

    /* Command and Control */
    ["T_2_12"]: `${genAiMatrixCategoryBaseUrl}/command_and_control.html`,
    ["T_2_12_1"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,
    ["T_2_12_2"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,

    /* Exfiltration */
    ["T_2_13"]: `${genAiMatrixCategoryBaseUrl}/exfiltration.html`,
    ["T_2_13_1"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,
    ["T_2_13_2"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,
    ["T_2_13_3"]: `${genAiMatrixBaseUrl}/web_request_triggering.html`,
    ["T_2_13_4"]: `${genAiMatrixBaseUrl}/clickable_link_rendering.html`,
    ["T_2_13_5"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,
    ["T_2_13_6"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,

    /* Impact */
    ["T_2_14"]: `${genAiMatrixCategoryBaseUrl}/impact.html`,
    ["T_2_14_1"]: `${genAiMatrixBaseUrl}/citation_manipulation.html`,
    ["T_2_14_2"]: `${genAiMatrixBaseUrl}/llm01-prompt-injection`,
    ["T_2_14_3"]: `${genAiMatrixBaseUrl}/rag_injection.html`,
};

const anyOwaspUrls: Record<string, string> = {
    ...owaspLcncUrls,
    ...owaspLlmUrls,
};

export const attackToDisplayName: Record<string, string> = {
    ["T1001"]: "data_obfuscation_T1001",
    ["T1003"]: "os_credential_dumping_T1003",
    ["T1005"]: "data_from_local_system_T1005",
    ["T1006"]: "direct_volume_access_T1006",
    ["T1007"]: "system_service_discovery_T1007",
    ["T1008"]: "fallback_channels_T1008",
    ["T1010"]: "application_window_discovery_T1010",
    ["T1011"]: "exfiltration_over_other_network_medium_T1011",
    ["T1012"]: "query_registry_T1012",
    ["T1014"]: "rootkit_T1014",
    ["T1016"]: "system_network_configuration_discovery_T1016",
    ["T1018"]: "remote_system_discovery_T1018",
    ["T1020"]: "automated_exfiltration_T1020",
    ["T1021"]: "remote_services_T1021",
    ["T1025"]: "data_from_removable_media_T1025",
    ["T1027"]: "obfuscated_files_or_information_T1027",
    ["T1029"]: "scheduled_transfer_T1029",
    ["T1030"]: "data_transfer_size_limits_T1030",
    ["T1033"]: "system_owner/user_discovery_T1033",
    ["T1036"]: "masquerading_T1036",
    ["T1037"]: "boot_or_logon_initialization_scripts_T1037",
    ["T1039"]: "data_from_network_shared_drive_T1039",
    ["T1040"]: "network_sniffing_T1040",
    ["T1041"]: "exfiltration_over_c2_channel_T1041",
    ["T1046"]: "network_service_discovery_T1046",
    ["T1047"]: "windows_management_instrumentation_T1047",
    ["T1048"]: "exfiltration_over_alternative_protocol_T1048",
    ["T1049"]: "system_network_connections_discovery_T1049",
    ["T1052"]: "exfiltration_over_physical_medium_T1052",
    ["T1053"]: "scheduled_task/job_T1053",
    ["T1055"]: "process_injection_T1055",
    ["T1056"]: "input_capture_T1056",
    ["T1057"]: "process_discovery_T1057",
    ["T1059"]: "command_and_scripting_interpreter_T1059",
    ["T1068"]: "exploitation_for_privilege_escalation_T1068",
    ["T1069"]: "permission_groups_discovery_T1069",
    ["T1070"]: "indicator_removal_T1070",
    ["T1071"]: "application_layer_protocol_T1071",
    ["T1072"]: "software_deployment_tools_T1072",
    ["T1074"]: "data_staged_T1074",
    ["T1078"]: "valid_accounts_T1078",
    ["T1080"]: "taint_shared_content_T1080",
    ["T1082"]: "system_information_discovery_T1082",
    ["T1083"]: "file_and_directory_discovery_T1083",
    ["T1087"]: "account_discovery_T1087",
    ["T1090"]: "proxy_T1090",
    ["T1091"]: "replication_through_removable_media_T1091",
    ["T1092"]: "communication_through_removable_media_T1092",
    ["T1095"]: "non-application_layer_protocol_T1095",
    ["T1098"]: "account_manipulation_T1098",
    ["T1102"]: "web_service_T1102",
    ["T1104"]: "multi-stage_channels_T1104",
    ["T1105"]: "ingress_tool_transfer_T1105",
    ["T1106"]: "native_api_T1106",
    ["T1110"]: "brute_force_T1110",
    ["T1111"]: "multi-factor_authentication_interception_T1111",
    ["T1112"]: "modify_registry_T1112",
    ["T1113"]: "screen_capture_T1113",
    ["T1114"]: "email_collection_T1114",
    ["T1115"]: "clipboard_data_T1115",
    ["T1119"]: "automated_collection_T1119",
    ["T1120"]: "peripheral_device_discovery_T1120",
    ["T1123"]: "audio_capture_T1123",
    ["T1124"]: "system_time_discovery_T1124",
    ["T1125"]: "video_capture_T1125",
    ["T1127"]: "trusted_developer_utilities_proxy_execution_T1127",
    ["T1129"]: "shared_modules_T1129",
    ["T1132"]: "data_encoding_T1132",
    ["T1133"]: "external_remote_services_T1133",
    ["T1134"]: "access_token_manipulation_T1134",
    ["T1135"]: "network_share_discovery_T1135",
    ["T1136"]: "create_account_T1136",
    ["T1137"]: "office_application_startup_T1137",
    ["T1140"]: "deobfuscate/decode_files_or_information_T1140",
    ["T1176"]: "browser_extensions_T1176",
    ["T1185"]: "browser_session_hijacking_T1185",
    ["T1187"]: "forced_authentication_T1187",
    ["T1189"]: "drive-by_compromise_T1189",
    ["T1190"]: "exploit_public-facing_application_T1190",
    ["T1195"]: "supply_chain_compromise_T1195",
    ["T1197"]: "bits_jobs_T1197",
    ["T1199"]: "trusted_relationship_T1199",
    ["T1200"]: "hardware_additions_T1200",
    ["T1201"]: "password_policy_discovery_T1201",
    ["T1202"]: "indirect_command_execution_T1202",
    ["T1203"]: "exploitation_for_client_execution_T1203",
    ["T1204"]: "user_execution_T1204",
    ["T1205"]: "traffic_signaling_T1205",
    ["T1207"]: "rogue_domain_controller_T1207",
    ["T1210"]: "exploitation_of_remote_services_T1210",
    ["T1211"]: "exploitation_for_defense_evasion_T1211",
    ["T1212"]: "exploitation_for_credential_access_T1212",
    ["T1213"]: "data_from_information_repositories_T1213",
    ["T1216"]: "system_script_proxy_execution_T1216",
    ["T1217"]: "browser_information_discovery_T1217",
    ["T1218"]: "system_binary_proxy_execution_T1218",
    ["T1219"]: "remote_access_software_T1219",
    ["T1220"]: "xsl_script_processing_T1220",
    ["T1221"]: "template_injection_T1221",
    ["T1222"]: "file_and_directory_permissions_modification_T1222",
    ["T1480"]: "execution_guardrails_T1480",
    ["T1482"]: "domain_trust_discovery_T1482",
    ["T1484"]: "domain_or_tenant_policy_modification_T1484",
    ["T1485"]: "data_destruction_T1485",
    ["T1486"]: "data_encrypted_for_impact_T1486",
    ["T1489"]: "service_stop_T1489",
    ["T1490"]: "inhibit_system_recovery_T1490",
    ["T1491"]: "defacement_T1491",
    ["T1495"]: "firmware_corruption_T1495",
    ["T1496"]: "resource_hijacking_T1496",
    ["T1497"]: "virtualization/sandbox_evasion_T1497",
    ["T1498"]: "network_denial_of_service_T1498",
    ["T1499"]: "endpoint_denial_of_service_T1499",
    ["T1505"]: "server_software_component_T1505",
    ["T1518"]: "software_discovery_T1518",
    ["T1525"]: "implant_internal_image_T1525",
    ["T1526"]: "cloud_service_discovery_T1526",
    ["T1528"]: "steal_application_access_token_T1528",
    ["T1529"]: "system_shutdown/reboot_T1529",
    ["T1530"]: "data_from_cloud_storage_T1530",
    ["T1531"]: "account_access_removal_T1531",
    ["T1534"]: "internal_spearphishing_T1534",
    ["T1535"]: "unused/unsupported_cloud_regions_T1535",
    ["T1537"]: "transfer_data_to_cloud_account_T1537",
    ["T1538"]: "cloud_service_dashboard_T1538",
    ["T1539"]: "steal_web_session_cookie_T1539",
    ["T1542"]: "pre-os_boot_T1542",
    ["T1543"]: "create_or_modify_system_process_T1543",
    ["T1546"]: "event_triggered_execution_T1546",
    ["T1547"]: "boot_or_logon_autostart_execution_T1547",
    ["T1548"]: "abuse_elevation_control_mechanism_T1548",
    ["T1550"]: "use_alternate_authentication_material_T1550",
    ["T1552"]: "unsecured_credentials_T1552",
    ["T1553"]: "subvert_trust_controls_T1553",
    ["T1554"]: "compromise_host_software_binary_T1554",
    ["T1555"]: "credentials_from_password_stores_T1555",
    ["T1556"]: "modify_authentication_process_T1556",
    ["T1557"]: "adversary-in-the-middle_T1557",
    ["T1558"]: "steal_or_forge_kerberos_tickets_T1558",
    ["T1559"]: "inter-process_communication_T1559",
    ["T1560"]: "archive_collected_data_T1560",
    ["T1561"]: "disk_wipe_T1561",
    ["T1562"]: "impair_defenses_T1562",
    ["T1563"]: "remote_service_session_hijacking_T1563",
    ["T1564"]: "hide_artifacts_T1564",
    ["T1565"]: "data_manipulation_T1565",
    ["T1566"]: "phishing_T1566",
    ["T1567"]: "exfiltration_over_web_service_T1567",
    ["T1568"]: "dynamic_resolution_T1568",
    ["T1569"]: "system_services_T1569",
    ["T1570"]: "lateral_tool_transfer_T1570",
    ["T1571"]: "non-standard_port_T1571",
    ["T1572"]: "protocol_tunneling_T1572",
    ["T1573"]: "encrypted_channel_T1573",
    ["T1574"]: "hijack_execution_flow_T1574",
    ["T1578"]: "modify_cloud_compute_infrastructure_T1578",
    ["T1580"]: "cloud_infrastructure_discovery_T1580",
    ["T1583"]: "acquire_infrastructure_T1583",
    ["T1584"]: "compromise_infrastructure_T1584",
    ["T1585"]: "establish_accounts_T1585",
    ["T1586"]: "compromise_accounts_T1586",
    ["T1587"]: "develop_capabilities_T1587",
    ["T1588"]: "obtain_capabilities_T1588",
    ["T1589"]: "gather_victim_identity_information_T1589",
    ["T1590"]: "gather_victim_network_information_T1590",
    ["T1591"]: "gather_victim_org_information_T1591",
    ["T1592"]: "gather_victim_host_information_T1592",
    ["T1593"]: "search_open_websites/domains_T1593",
    ["T1594"]: "search_victim-owned_websites_T1594",
    ["T1595"]: "active_scanning_T1595",
    ["T1596"]: "search_open_technical_databases_T1596",
    ["T1597"]: "search_closed_sources_T1597",
    ["T1598"]: "phishing_for_information_T1598",
    ["T1599"]: "network_boundary_bridging_T1599",
    ["T1600"]: "weaken_encryption_T1600",
    ["T1601"]: "modify_system_image_T1601",
    ["T1602"]: "data_from_configuration_repository_T1602",
    ["T1606"]: "forge_web_credentials_T1606",
    ["T1608"]: "stage_capabilities_T1608",
    ["T1609"]: "container_administration_command_T1609",
    ["T1610"]: "deploy_container_T1610",
    ["T1611"]: "escape_to_host_T1611",
    ["T1612"]: "build_image_on_host_T1612",
    ["T1613"]: "container_and_resource_discovery_T1613",
    ["T1614"]: "system_location_discovery_T1614",
    ["T1615"]: "group_policy_discovery_T1615",
    ["T1619"]: "cloud_storage_object_discovery_T1619",
    ["T1620"]: "reflective_code_loading_T1620",
    ["T1621"]: "multi-factor_authentication_request_generation_T1621",
    ["T1622"]: "debugger_evasion_T1622",
    ["T1647"]: "plist_file_modification_T1647",
    ["T1648"]: "serverless_execution_T1648",
    ["T1649"]: "steal_or_forge_authentication_certificates_T1649",
    ["T1650"]: "acquire_access_T1650",
    ["T1651"]: "cloud_administration_command_T1651",
    ["T1652"]: "device_driver_discovery_T1652",
    ["T1653"]: "power_settings_T1653",
    ["T1654"]: "log_enumeration_T1654",
    ["T1656"]: "impersonation_T1656",
    ["T1657"]: "financial_theft_T1657",
    ["T1659"]: "content_injection_T1659",
    ["T1665"]: "hide_infrastructure_T1665",
};

export const getViolationRuleToAttackLinks = (attack: string) => `${attackBaseUrl}/${attack}/`;

export const getViolationRuleToOwaspLinks = (owasp: string) => `${anyOwaspUrls[owasp] ?? ""}`;

export const getViolationRuleToGenAiMatrixLinks = (genAiMatrix: string) => `${genAiMatrixUrls[genAiMatrix] ?? ""}`;

export const getviolationRuleRiskReasonCardFieldKey = (owasp: string): string => {
    const owaspList = getOwaspList(owasp);
    switch (owaspList) {
        case "LCNC":
            return "violationPage.riskReasonCardLcncOwaspFieldKey";
        case "LLM":
            return "violationPage.riskReasonCardLlmOwaspFieldKey";
    }
};

function getOwaspList(owasp: string): OwaspList {
    const owaspPrefix = owasp.split("-")[0];
    switch (owaspPrefix) {
        case "LCNC":
            return "LCNC";
        case "LLM":
            return "LLM";
        default:
            throw new Error(`Invalid OWASP prefix: ${owaspPrefix}`);
    }
}
